const naturalStringCollator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: 'accent',
  ignorePunctuation: true,
});

export function compareNaturalStrings(a: string, b: string) {
  return naturalStringCollator.compare(a, b);
}
